import ScrollTrigger from "gsap/ScrollTrigger";

console.log('timeline');

/* Layout generic */

gsap.from(".nav-item", { 
    y: -20, 
    duration: .2, 
    delay: .25,
    stagger: 0.1,
    opacity: 0, 
});


gsap.registerPlugin(ScrollTrigger);

const cards = gsap.utils.toArray('.card');
cards.forEach( (card, index)  => {
    gsap.from(card, { 
        opacity: 0,
        duration: 1,
        delay: index * .25,
        scrollTrigger: {
            trigger: card,
            toggleActions: "play none none none",
            markers: false,
            start: "center bottom",
            end: "+=200px",
            scrub: true,
            onLeave: function(self) {    
                self.scroll(self.end);	// <-- sets position to start of ScrollTrigger
                self.disable()
                self.animation.progress(1)
            }
        },
    })
});


const events = gsap.utils.toArray('.event');
events.forEach( (event, index)  => {
    gsap.from(event, { 
            scrollTrigger: {
            trigger: event,
            toggleActions: "play none none none",
            markers: false,
            start: "center bottom",
            end: "+=50px",
            scrub: true,           
             onLeave: function(self) {    
                self.scroll(self.end);
                self.disable()
                self.animation.progress(1)
            }
        },
        y: 20,
        opacity: 0.35,
        duration: .1,
    })
});


/* Nav animaiton */

gsap.to('.brand', {
    scrollTrigger: {
        trigger: '.hero-section',
        start: "+500px",
        end: '+1500px',
        markers: false,
        scrub: true,
    },
    scale: .75,
})


gsap.to('nav.navbar', {
    scrollTrigger: {
        trigger: '.hero-section',
        start: "+500px",
        end: '+1500px',
        scrub: true,
    },
    paddingTop: 0,
    paddingBottom: 0,
    /* height: "75px",
    onEnter: () => {
        navbarEl.forEach(el => el.style.marginTop = "-3px");
    },
    onLeave: () => {
        navbarEl.forEach(el => el.style.marginTop = "auto");
    } */
})






